import { Button } from '@portals/core/src/components/Button/Button';
import React, { ComponentProps, MouseEventHandler, ReactElement } from 'react';

import { ContentButton as ContentButtonModel } from '../../../models';
import { Node } from '../../consumers/Consumer/Consumer';
import { useLinkProps } from '../../hooks/useLinkProps';
import { loadIcon } from '../../utils/loadIcon';
import { CategoryIcon } from '../CategoryIcon/CategoryIcon';

interface Props {
  node: ContentButtonModel;
  children: React.ReactNode;
  onClick?: MouseEventHandler<HTMLElement>;
  sx?: ComponentProps<typeof Button>['sx'];
  renderNode: (node: Node) => ReactElement;
}

export const ContentButton: React.FunctionComponent<Props> = ({
  node: { id, __component, startIcon, endIcon, categoryIcon, link, ...props },
  children,
  onClick,
  sx,
  renderNode,
}: Props) => {
  const { singleProps } = useLinkProps(link && link[0]);
  const Icon = loadIcon(startIcon?.icon);
  const iconOfType = categoryIcon ? (
    <CategoryIcon category={categoryIcon.icon} />
  ) : startIcon ? (
    <Icon fontSize="medium" />
  ) : null;

  return (
    <Button
      id={`${__component}.${id}`}
      {...props}
      {...singleProps}
      onClick={onClick || singleProps.onClick}
      startIcon={iconOfType}
      endIcon={endIcon ? renderNode(endIcon) : null}
      sx={sx}
    >
      {children}
    </Button>
  );
};
